import React, { useState, useEffect } from 'react';
import Helpers from 'utils/helpers';

export default function RadioGroup(props) {
  const [selectedValue, setSelectedValue] = useState();
  const [childRadios, setChildRadios] = useState([]);
  const [name] = useState(props.name || 'group-' + (Math.floor(Math.random() * 999999999) + 100000000).toString());

  useEffect(() => {
    const newRadios = [];
    React.Children.forEach(props.children, (child) => {
      newRadios.push({
        ...child,
        props: {
          ...child.props,
          name: name,
          checked: (child.props.value === selectedValue),
          onChange: () => handleChange(child.props.value),
        }
      });
    });
    setChildRadios(newRadios);
  }, [props.children, selectedValue, name]);

  useEffect(() => {
    if (Helpers.Object.exists(props.value)) {
      setSelectedValue(props.value);
    }
    else if (Helpers.Object.exists(props.defaultValue)) {
      setSelectedValue(props.defaultValue);
    }
  }, [props.value, props.defaultValue]);

  const handleChange = (value) => {
    setSelectedValue(value);
    if (props.onChange) {
      props.onChange(value);
    }
    if (props.onValueChange) {
      props.onValueChange(value);
    }
  };

  return childRadios;
}